import classnames from "classnames";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import React from "react";

import {DESTINATION_TYPE} from "config/constants";
import {Destination} from "v2/api/Records";

const DestinationFlag = (props) => {
  const {
    data: {checkinTime, checkoutTime, estStartTime, type, traineePickedUp},
    sidebar,
  } = props;
  if (!checkinTime && sidebar) {
    return null;
  }

  let className;
  let iconName;
  let title;

  if (checkinTime) {
    if (!checkoutTime) {
      className = "text-warning";
      iconName = "fa-ellipsis-h";
      title = `Started ${checkinTime.fromNow()}`;
    } else if (type === DESTINATION_TYPE.pickupTrainee && !traineePickedUp) {
      className = "text-danger";
      iconName = "fa-exclamation-triangle";
      title = "Trainee didn't show";
    } else {
      className = "text-success";
      iconName = "fa-check";
      title = `Completed ${checkinTime.fromNow()}`;
    }
  } else if (moment().isBefore(estStartTime)) {
    className = "text-muted";
    iconName = "fa-clock-o";
    title = `Starts ${moment().to(estStartTime)}`;
  } else {
    className = "text-danger";
    iconName = "fa-exclamation-triangle";
    title = `Started ${estStartTime.fromNow()}`;
  }

  className = classnames("DestinationFlag", className, {
    "pull-right": sidebar,
  });
  return (
    <span className={className}>
      <i className={classnames("fa", iconName)} title={title} />
      {!sidebar && <span className="erg-margin-left-5">{title}</span>}
    </span>
  );
};

DestinationFlag.defaultProps = {
  sidebar: false,
};
DestinationFlag.propTypes = {
  data: PropTypes.instanceOf(Destination).isRequired,
  sidebar: PropTypes.bool,
};

export default DestinationFlag;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DestinationFlag.js
 **/